<div class="breadcrumb-container" *ngIf="breadcrumbs.length > 0">
    <nav class="breadcrumb-nav">
        <ol class="breadcrumb-list">
            <li class="breadcrumb-item"
                *ngFor="let breadcrumb of breadcrumbs; let last = last">
                <ng-container *ngIf="!last; else lastItem">
                    <a *ngIf="breadcrumb.clickable !== false" 
                        class="breadcrumb-link"
                        (click)="navigateToBreadcrumb(breadcrumb)"
                        [title]="breadcrumb.label">
                        {{ breadcrumb.label }}
                    </a>
                    <span *ngIf="breadcrumb.clickable === false" 
                        class="breadcrumb-link breadcrumb-non-clickable"
                        [title]="breadcrumb.label">
                        {{ breadcrumb.label }}
                    </span>
                </ng-container>

                <ng-template #lastItem>
                    <span class="breadcrumb-current">{{ breadcrumb.label
                        }}</span>
                </ng-template>

            </li>
        </ol>
    </nav>
</div>